import React from "react";

import PageHeading from "2g-page-heading";

import { FixniPozadavkyBoxErrorContent } from "b2b/components/fixni-pozadavky-box/FixniPozadavkyBoxErrorContent";

const FAZE_OBDOBI_FIXNI = {
  openDay: "pondělí",
  openHours: "12",
  closeDay: "středa",
  closeHours: "08"
};

const FAZE_OBDOBI_VSECHNY = {
  openDay: "čtvrtek",
  openHours: "08",
  closeDay: "pátek",
  closeHours: "12"
};

export function FixniPozadavkyBoxErrorContentExample() {
  return (
    <div>
      <PageHeading>Only fixni</PageHeading>
      <div data-testid="open-fixni">
        <FixniPozadavkyBoxErrorContent
          isError
          loading={false}
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: true,
            vsechny: false
          }}
        />
      </div>
      <PageHeading>closed</PageHeading>
      <div data-testid="open-fixni">
        <FixniPozadavkyBoxErrorContent
          isError
          loading={false}
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: false,
            vsechny: false
          }}
        />
      </div>
      <PageHeading>closed - showObdobi=false</PageHeading>
      <div data-testid="open-fixni">
        <FixniPozadavkyBoxErrorContent
          isError
          showObdobi={false}
          loading={false}
          fazeObdobiFixni={FAZE_OBDOBI_FIXNI}
          fazeObdobiVsechny={FAZE_OBDOBI_VSECHNY}
          faze={{
            fixni: false,
            vsechny: false
          }}
        />
      </div>
    </div>
  );
}

FixniPozadavkyBoxErrorContentExample.propTypes = {};

export default React.memo(FixniPozadavkyBoxErrorContentExample);
